import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams, DocumentSignedURL } from '../../../types/main';
import { ItemId, Document } from '../../../types/items';
import { MediaFormDocument } from '../../../types/formItems';
import {
  DocumentDownloadRequest,
  DocumentDownloadSuccess,
  FormHandler,
  FormDocument,
} from './types';

export const initDocumentRequest = action(
  'INIT_DOCUMENT_REQUEST',
  withoutPayload,
);
export const initDocumentSuccess = action(
  'INIT_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const initDocumentFail = action(
  'INIT_DOCUMENT_FAIL',
  withoutPayload,
);

export const createDocumentRequest = action(
  'CREATE_DOCUMENT_REQUEST',
  withPayload<Document>(),
);
export const createDocumentSuccess = action(
  'CREATE_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const createDocumentFail = action(
  'CREATE_DOCUMENT_FAIL',
  withoutPayload,
);

export const getDocumentListRequest = action(
  'GET_DOCUMENT_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getDocumentListSuccess = action(
  'GET_DOCUMENT_LIST_SUCCESS',
  withPayload<ItemList<Document>>(),
);
export const getDocumentListFail = action(
  'GET_DOCUMENT_LIST_FAIL',
  withoutPayload,
);

export const setDocumentListDirty = action(
  'SET_DOCUMENT_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getDocumentRequest = action(
  'GET_DOCUMENT_REQUEST',
  withPayload<ItemId>(),
);
export const getDocumentSuccess = action(
  'GET_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const getDocumentFail = action(
  'GET_DOCUMENT_FAIL',
  withoutPayload,
);

export const resetCurrentDocument = action(
  'RESET_CURRENT_DOCUMENT',
  withoutPayload,
);

export const saveDocumentRequest = action(
  'SAVE_DOCUMENT_REQUEST',
  withPayload<Document | MediaFormDocument>(),
);
export const saveDocumentSuccess = action(
  'SAVE_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const saveDocumentFail = action(
  'SAVE_DOCUMENT_FAIL',
  withoutPayload,
);

export const deleteDocumentRequest = action(
  'DELETE_DOCUMENT_REQUEST',
  withPayload<ItemId>(),
);
export const deleteDocumentSuccess = action(
  'DELETE_DOCUMENT_SUCCESS',
  withPayload<ItemId>(),
);
export const deleteDocumentFail = action(
  'DELETE_DOCUMENT_FAIL',
  withoutPayload,
);

export const syncDocumentRequest = action(
  'SYNC_DOCUMENT_REQUEST',
  withPayload<ItemId>(),
);
export const syncDocumentSuccess = action(
  'SYNC_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const syncDocumentFail = action(
  'SYNC_DOCUMENT_FAIL',
  withoutPayload,
);

export const syncTypesDocumentRequest = action(
  'SYNC_TYPES_DOCUMENT_REQUEST',
  withoutPayload,
);
export const syncTypesDocumentSuccess = action(
  'SYNC_TYPES_DOCUMENT_SUCCESS',
  withPayload<number[]>(),
);
export const syncTypesDocumentFail = action(
  'SYNC_TYPES_DOCUMENT_FAIL',
  withoutPayload,
);

export const getDocumentUploadUrlRequest = action(
  'GET_DOCUMENT_UPLOAD_URL_REQUEST',
  withPayload<ItemId>(),
);
export const getDocumentUploadUrlSuccess = action(
  'GET_DOCUMENT_UPLOAD_URL_SUCCESS',
  withPayload<DocumentSignedURL>(),
);
export const getDocumentUploadUrlFail = action(
  'GET_DOCUMENT_UPLOAD_URL_FAIL',
  withoutPayload,
);

export const getDocumentDownloadRequest = action(
  'GET_DOCUMENT_DOWNLOAD_REQUEST',
  withPayload<DocumentDownloadRequest>(),
);
export const getDocumentDownloadSuccess = action(
  'GET_DOCUMENT_DOWNLOAD_SUCCESS',
  withPayload<DocumentDownloadSuccess>(),
);
export const getDocumentDownloadFail = action(
  'GET_DOCUMENT_DOWNLOAD_FAIL',
  withoutPayload,
);

export const setDocumentForm = action(
  'SET_DOCUMENT_FORM',
  withPayload<FormDocument>(),
);

export const setDocumentFormsReset = action(
  'SET_DOCUMENT_FORMS_RESET',
  withPayload<boolean>(),
);

export const setDocumentFormsSubmit = action(
  'SET_DOCUMENT_FORMS_SUBMIT',
  withPayload<boolean>(),
);

export const submitDocumentForm = action(
  'SUBMIT_DOCUMENT_FORM',
  withPayload<FormHandler>(),
);

export const removeDocumentForm = action(
  'REMOVE_DOCUMENT_FORM',
  withPayload<number>(),
);

export const resetDocumentForm = action(
  'RESET_DOCUMENT_FORM',
  withPayload<FormHandler>(),
);
